import {FormatterBasic} from "./Core/FormatterBasic";

export class NameFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}